// extracted by mini-css-extract-plugin
export default {"backToTop":"BackToTop_backToTop--dBX","custom":"BackToTop_custom--Jhg"};